__turbopack_context__.v({
  "rteDocumentStyles": "common-module__H54Uiq__rteDocumentStyles",
  "rteFormStyles": "common-module__H54Uiq__rteFormStyles",
});
